import * as React from 'react'

import { TasksValueObjectsTaskIdentifierEnum } from 'generated/resources/graphql'

import EditTaskModal from 'modules/tasks/components/EditTaskModal'

import { TasksDataTable as TasksTable } from './DataTable'

interface Props {
  involveeId?: number
  identifier?: TasksValueObjectsTaskIdentifierEnum
  hideActions: boolean
  isExternalUser: boolean
  employeeId?: number
  canManageTasks?: boolean
}

const TasksList = ({
  involveeId,
  identifier,
  hideActions,
  isExternalUser,
  employeeId,
  canManageTasks,
}: Props) => {
  const [taskId, setTaskId] = React.useState<number>()

  const onClose = () => {
    setTaskId(undefined)
  }

  return (
    <>
      <TasksTable
        involveeId={involveeId}
        onEdit={setTaskId}
        identifier={identifier}
        hideActions={hideActions}
        isExternalUser={isExternalUser}
        employeeId={employeeId}
        canManageTasks={canManageTasks}
      />
      {taskId && <EditTaskModal taskId={taskId} onClose={onClose} />}
    </>
  )
}

export default TasksList
